import { Injectable } from '@angular/core';
import { CodePush, InstallMode, SyncStatus } from '@ionic-native/code-push';
import { Loading, LoadingController } from 'ionic-angular';

@Injectable()
export class CodePushServiceProvider {
  loading: Loading;
  install: Loading;
  update: Loading;
  check: Loading;

  constructor(private codePush: CodePush, private loadingCtrl: LoadingController) {}

  checkVersionUpdatesThroughCodepush() {
    return new Promise((resolve, reject) => {
      if (!(<any>window).codePush) {
        console.log('window.codePush undefined, aborting checks');
        return resolve(true);
      }
      this.check = this.loadingCtrl.create({
        content: 'Sprawdzanie wersji...',
      });
      this.check.present();
      console.log('Checking code-push version');
      this.codePush.checkForUpdate().then(
        (remotePackage) => {
          this.check.dismiss();
          if (!remotePackage) {
            console.log('Up to date');
            resolve('applicationIsUpToDate');
          } else {
            this.update = this.loadingCtrl.create({
              content: 'Trwa aktualizacja...',
            });
            this.update.present();
            console.log('Downloading update');
            remotePackage.download(installCodePushUpdate, (error) => {
              console.log('Error when downloading: ' + error);
              reject();
            });
          }
        },
        (error) => {
          if (this.check) this.check.dismiss();
          console.log('Error when checking for update: ' + error);
          reject();
        },
      );

      function installCodePushUpdate(localPackage) {
        console.log('Downloading finished, installing...');
        localPackage.install(
          function () {
            console.log('Installed!');
            resolve('installationSuccess');
          },
          (error) => {
            console.log('Error when installing: ' + error);
            reject();
          },
          { installMode: InstallMode.ON_NEXT_RESTART },
        );
      }
    });
  }

  checkAndUpdate() {
    return this.checkVersionUpdatesThroughCodepushSync();
  }

  checkVersionUpdatesThroughCodepushSync() {
    return new Promise((resolve, reject) => {
      this.codePush.sync({ updateDialog: false, installMode: InstallMode.IMMEDIATE }).subscribe(
        (syncState) => {
          switch (syncState) {
            case SyncStatus.UP_TO_DATE:
              console.log('[CodePush] SyncStatus.UP_TO_DATE');
              this.dismissLoadingIndicatorIfExists(this.check);
              resolve('applicationIsUpToDate');
              break;
            case SyncStatus.CHECKING_FOR_UPDATE:
              this.check = this.loadingCtrl.create({
                content: 'Sprawdzanie wersji oprogramowania...',
                dismissOnPageChange: true,
              });
              this.check.present();
              break;
            case SyncStatus.INSTALLING_UPDATE:
              console.log('[CodePush] SyncStatus.INSTALLING_UPDATE');
              break;
            case SyncStatus.DOWNLOADING_PACKAGE:
              console.log('[CodePush] SyncStatus.DOWNLOADING_PACKAGE');
              this.dismissLoadingIndicatorIfExists(this.check);
              this.install = this.loadingCtrl.create({
                content: 'Trwa aktualizacja...',
                dismissOnPageChange: true,
              });
              this.install.present();
              break;
            case SyncStatus.ERROR:
              console.error('[CodePush] SyncStatus.ERROR');
              this.dismissLoadingIndicatorIfExists(this.check);
              this.dismissLoadingIndicatorIfExists(this.install);
              reject();
              break;
            case SyncStatus.UPDATE_INSTALLED:
              console.log('[CodePush] SyncStatus.UPDATE_INSTALLED');
              this.dismissLoadingIndicatorIfExists(this.check);
              this.dismissLoadingIndicatorIfExists(this.install);
              resolve('installationSuccess');
              break;
            default:
              console.error(`[CodePush] Unexpected SyncStatus returned: "${syncState}"`);
              this.dismissLoadingIndicatorIfExists(this.check);
              this.dismissLoadingIndicatorIfExists(this.install);
              resolve('unexpectedSyncStatus');
          }
        },
        (error) => {
          console.error('[CodePush] An error occured', error);
          this.dismissLoadingIndicatorIfExists(this.check);
          this.dismissLoadingIndicatorIfExists(this.install);
          reject();
        },
      );
    });
  }

  private dismissLoadingIndicatorIfExists(loadingIndicator: Loading): void {
    if (loadingIndicator) {
      loadingIndicator.dismiss();
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/code-push-service/code-push-service.ts